import React, { Fragment } from 'react';

const getDecorator = ( params ) =>
{
    const options = { key: 'DecLabel', className: 'glyphicon ' + params.decorator.icon, style: { float: 'right', cursor: 'pointer', color: params.decorator.color, marginLeft: '10px' } } ;

    options.onClick = params.decorator.onClick ;

    options['data-tip'] = params.decorator.tip ;

    return <span { ...options }/>
}

export const getPanelHeader = ( params ) =>
{
    return (
        <div className='panel-heading' key='heading1'>
            <span key='Decorator1'>{params.title}</span>
            { params.decorator !== null && params.decorator !== undefined && getDecorator(params)}
        </div>
    )
}